import * as actions from "./actions";
import {
   initMemberships,
   initCandidatePayment,
   paymentPurchase,
   initMembershipById,
   initPaymentDeclined,
   initWallet,
   initTip,
   initMediaUnlock,
   paymentPurchaseUsingWallet,
   chatAvailablePrices,
   chatSettingsInfo,
}  from 'sites/api/AuthApi';
import {
   getVideoById,
   getPhotosetById,
   initStoreById,
   videoAvailablePrices,
   photosetAvailablePrices,
   liveStreamAvailablePrices,
   initLiveStream,
   validatePromoCode,
   pollAvailablePrices,
} from 'sites/api/MixApi'
import { push } from 'connected-react-router';
import Router from 'sites/routes/router';
import toster from 'common/utils/toast';
import QueryParams from "sites/utils/QueryParams";
import { upperCaseFirstLetter, onUnavailableLivestreamPurchase } from 'common/utils/utils'

// import LocalStorage from "sites/utils/LocalStorage";

export function fetchMembershipsData(params, query, isFetchingByCode = false, codeByLink = '') {
   return async (dispatch) => {
      dispatch(actions.fetchMembershipRequest(isFetchingByCode));
      if(Boolean(codeByLink)){
         try {
            await dispatch(validatePromoCodeOperation(codeByLink, true))
         } catch (error) {

         }
      }
      try {
         const { data } = await initMemberships(query);
         let availablePrices = { data: null };
         try {
            if(params && params.type === 'video' && params.id) {
               availablePrices = await videoAvailablePrices(params.id);
            } else if(params && params.type === 'photoset' && params.id) {
               availablePrices = await photosetAvailablePrices(params.id);
            } else if(params && params.type === 'chat'){
               availablePrices = await chatAvailablePrices();
            } else if(params && params.type === 'live_stream' && params.id){
               availablePrices = await liveStreamAvailablePrices(params.id);
            } else if(params && params.type === 'record' && params.id){
               availablePrices = await videoAvailablePrices(params.id, '?video_type=livestream');
            } else if(params && params.type === 'poll' && params.id) {
               availablePrices = await pollAvailablePrices(params.id);
            }

         } catch (error) {

         }
         dispatch(actions.fetchMembershipCompleted(data, availablePrices.data));
      } catch (error) {
         dispatch(actions.fetchMembershipFailed(error));
      }
   };
}

export function fetchPaymentOptions(id, type = 'membership') {
   return async (dispatch) => {
      dispatch(actions.fetchPaymentOptionsRequest());
      try {
         const apiType = {
            membership: 'membership-pricings',
            video: 'videos',
            photoset: 'photosets',
            store: 'products',
            wallet_top_up: 'wallet',
            tip: 'tip',
            photo_unlock: 'chat/messages',
            video_unlock: 'chat/messages',
            voice_unlock: 'chat/messages',
            live_stream: 'live-stream',
            chat: 'chat',
            multiple_attachment: 'chat/messages',
         }
         const { data } = await initCandidatePayment(id, apiType[type]);
         dispatch(actions.fetchPaymentOptionsCompleted(data));
      } catch (error) {
         dispatch(actions.fetchPaymentOptionsFailed(error));
      }
   };
}
export function purchaseOptions(data, withoutChange = false, id) {
   return async (dispatch) => {
      dispatch(actions.paymentPurchaseRequest());
      let isUnavailableLivestreamPurchase = false;
      if('livestream' ===  data.type){
         const response = await initLiveStream();
         isUnavailableLivestreamPurchase = onUnavailableLivestreamPurchase(response.data, id)
      }
      if(isUnavailableLivestreamPurchase){
         dispatch(actions.paymentPurchaseRequest(false));
         return;
      }
      let sendData = {
         payment_method: data.payment_method,
         payment_system: data.payment_system,
         id: data.id,
         type: data.type,
      }

      if(data.resource_id && data.resource_type) {
         sendData.resource_id = data.resource_id
         sendData.resource_type = data.resource_type
      }
      if(data.note) {
         sendData.note = data.note
      }
      if(!withoutChange){
         switch (data.type) {
            case 'video':
            case 'photoset':
               let paymentType = 'unlock'
               if(data?.extra_info && data.extra_info?.payment_type) {
                  paymentType = data.extra_info.payment_type.replace('_content', '');
               }
               sendData.type = `${ data.type }_${ paymentType }`;
               if(data?.extra_info && data.extra_info?.video_type){
                  sendData.extra_info = {
                     ...sendData.extra_info,
                     video_type: data.extra_info?.video_type,
                  }
               }
               break;
            case 'video_unlock':
            case 'photo_unlock':
            case 'voice_message':
               sendData.type = `chat_${ data.type }`;
               if('voice_message' === data.type){
                  sendData.type = 'chat_voice_unlock';
               }
               break;
            case 'livestream':
               sendData.type = 'live_stream_unlock';
               break
            default:
               if(data.extra_info) {
                  sendData.extra_info = data.extra_info;
               }
               break;
         }
      } else if(data.extra_info){
         sendData.extra_info = data.extra_info;
      }
      if(data.type === 'livestream') {
         sendData.type = 'live_stream_unlock';
      }
      if(data.type === 'store'){
         sendData = {
            ...sendData,
            ...data,
         }
      }

      if(data.paymid_payload) {
         sendData.paymid_payload = data.paymid_payload
      }

      console.log('retry', sendData);

      // const affiliateId = LocalStorage.getItem('affiliateId')

      // if(affiliateId) {
      //    if(sendData?.extra_info) {
      //       sendData.extra_info = {
      //          ...sendData?.extra_info,
      //          affiliate_id: affiliateId,
      //       }
      //    } else  {
      //       sendData.extra_info = {
      //          affiliate_id: affiliateId,
      //       }
      //    }
      // }


      try {
         const response =  await paymentPurchase(sendData);
         setTimeout(() => {
            dispatch(actions.updatePaymentMethodMemberCompleted(data));
         }, 2000)
         window.location.href = response.data
      } catch (error) {
         console.log(error);
         let errorData = {}
         if(error && error.response) {
            if(error.response.status === 429) {

               toster.error('Too many attempts, please try again later');
            }
            else if(error.response.status === 422){
               toster.error(error.response.data.message);
            } else if(error.response.status === 406){
               toster.error(error.response.data.body);
            }  else {
               errorData = error.response?.data;
               if(typeof errorData !== 'string'){
                  errorData.payment_type = sendData.type
               }
            }
         } else {
            toster.error('Something went wrong');
         }

         dispatch(actions.paymentPurchaseFailed(errorData));

      }
   };
}
export function purchaseUsingWalletOptions(data) {
   return async (dispatch) => {
      dispatch(actions.paymentPurchaseUsingWalletRequest(true));
      try {
         await paymentPurchaseUsingWallet(data);
         dispatch(actions.paymentPurchaseUsingWalletRequest(false));
         let path = '';
         let successText = '';
         switch (data.type) {
            case 'video_unlock':
            case 'video_download':
               path = 'VIDEOS_INDIVIDUAL';
               break;
            case 'photoset_unlock':
            case 'photoset_download':
               path = 'PHOTOSETS_INDIVIDUAL';
               break;
            case 'chat_video_unlock':
            case 'chat_photo_unlock':
            case 'mass_message':
               path = 'CHAT_UNLCOKED_CONTENT';
               break;
            case 'tip':
               path = 'HOMEPAGE';
               successText = 'Tip send'
               break;
            case 'livestream':
               path = 'LIVE_STREAM_STUDIO';
               break;

            default:
               break;
         }
         if(successText) {
            toster.success(successText);
         }
         dispatch(actions.paymentPurchaseFailed(null));

         dispatch(push(Router.route(path).getCompiledPath({ id: data.id })));
      } catch (error) {
         toster.error('Something went wrong');
         dispatch(actions.paymentPurchaseUsingWalletRequest(false));

      }
   };
}

export function savePaymentMethodOptions(data) {
   return async (dispatch) => {
      dispatch(actions.savePaymentMethodMemberCompleted(data));
      dispatch(push(Router.route('JOIN_TERMS_OF_USE').getCompiledPath()));
   };
}
export function goToPaymentOptions(data, params = '') {
   return async (dispatch) => {
      let type = data.type || 'membership'
      if((type === 'mass_message' || type === 'private_mass_message') && data.extra_info?.unlock_type){
         type = data.extra_info.unlock_type
      }
      dispatch(actions.choosePurchaseCompleted(data));
      let path = '';
      let prefix = '';
      switch (type) {
         case 'membership':
            path = 'PURCHASE_MEMBERSHIP';
            break;
         case 'video_download':
         case 'video_unlock':
            path = 'PURCHASE_VIDEO';
            prefix = type.replace('video_', '');
            params = `payment_type=${ prefix }_content`;
            if(data.extra_info && 'livestream' === data.extra_info.video_type){
               params = `${ params }&video_type=livestream`;
            }
            break;
         case 'photoset_download':
         case 'photoset_unlock':
            path = 'PURCHASE_PHOTOSET';
            prefix = type.replace('photoset_', '');
            params = `payment_type=${ prefix }_content`;
            break;
         case 'store':
            path = 'PURCHASE_STORE';
            break;
         case 'wallet_top_up':
            path = 'PURCHASE_WALLET';
            break;
         case 'tip':
            path = 'PURCHASE_TIP';
            break;
         case 'chat_video_unlock':
            path = 'PURCHASE_VIDEO_UNLOCK';
            params = `type=video_unlock`
            break;
         case 'chat_photo_unlock':
            path = 'PURCHASE_PHOTO_UNLOCK';
            params = `type=photo_unlock`
            break;
         case 'chat_voice_unlock':
            path = 'PURCHASE_VOICE_UNLOCK';
            params = `type=voice_unlock`
            break;
         case 'livestream':
            path = 'PURCHASE_LIVE_STREAM';
            break;
         case 'multiple_attachment':
            path = 'PURCHASE_MULTIPLE_ATTACHMENT';
            break;
         default:
            break;
      }
      if(!!path) {
         dispatch(push({
            pathname: Router.route(path).getCompiledPath({ id: data.id }),
            search: params,
         }))
      }
   };
}

export function fetchActivePurchaseOperations(id, type, paymentType, videoType, promoCode) {
   return async (dispatch) => {
      try {
         let response = { data: {} }
         switch (type) {
            case 'membership':
               response = await initMembershipById(id, Boolean(promoCode) ? `promo_code=${ promoCode }` : '');
               break;
            case 'video':
               let apiQuery = '';
               if(videoType) {
                  apiQuery = `?video_type=${ videoType }`
               }

               response = await getVideoById(id, apiQuery);
               break;
            case 'photoset':
               response = await getPhotosetById(id);
               break;
            case 'store':
               response = await initStoreById(id);
               break;
            case 'wallet_top_up':
               response = await initWallet();
               break;
            case 'tip':
               response = await initTip(id);
               break;
            case 'photo_unlock':
            case 'video_unlock':
            case 'voice_unlock':
            case 'multiple_attachment':
               response = await initMediaUnlock(id);
               break;
            case 'livestream':
               response = await initLiveStream();
               const isUnavailableLivestreamPurchase =  onUnavailableLivestreamPurchase(response.data, id)
               if(isUnavailableLivestreamPurchase){
                  dispatch(push(Router.route('HOMEPAGE').getCompiledPath()));
               }
               break;
            case 'chat':
               response = await chatSettingsInfo();
               if('payed' !== response?.data?.type){
                  dispatch(push(Router.route('HOMEPAGE').getCompiledPath()));
               }
               break;
            default:
               break;
         }
         let { data } = response
         let purchase = {}
         if(type === 'wallet_top_up') {
            const purchaseData = data.filter(item => item.id === id);
            const terms = purchaseData[0].amount
            purchase = {
               id: id,
               type: type,
               name: 'Wallet top up',
               usd_terms: terms,
            }
         } else if(type === 'tip') {
            purchase = {
               id: id,
               usd_terms: id,
               type: type,
               name: 'Tip',
            }
         } else if(['video_unlock', 'photo_unlock', 'voice_unlock', 'multiple_attachment'].includes(type)) {
            const name = type.split('_').join(' ');
            purchase = {
               id: id,
               usd_terms: data.unlock_details.unlock_price,
               type,
               name: upperCaseFirstLetter(name),
            }
            purchase.type = data.type
         } else if(type === 'store') {
            purchase = {
               id: data.id,
               usd_terms: data.price,
               type: type,
               name: data.name,
            }
         } else if(type === 'chat') {
            const typeState = {
               chat_text_message: {
                  name: 'Chat text message',
                  usd_terms: `${ data.price } USD`,
               },
               chat_voice_message: {
                  name: 'Chat voice message',
                  usd_terms: `${ data.voice_message_price } USD`,
               },
               chat_photo_message: {
                  name: 'Chat image message',
                  usd_terms: `${ data.photo_message_price } USD`,
               },
            }
            const state = typeState?.[id] || {};
            purchase = {
               id: data.id,
               type: data.id,
               ...state,
            }
         }
         else {
            const promotionFullDiscount = data?.promotion &&  'first_payment' === data.promotion?.discount_type && 100 === data.promotion?.discount_percentage;
            purchase = {
               id: data.id,
               usd_terms: (data.is_can_not_use_trial ? data.recurring_terms :  data.usd_terms) || data.stream_price,
               type: type,
               name: data.name || data.title,
               trialExpiryDate: data.date_of_trial_expiry,
               isFreeTrial: (data.is_free_trial && !data?.is_can_not_use_trial) || promotionFullDiscount,
               recurringPrice: data.usd_recurring_price,
               isUsedTrial: data.is_can_not_use_trial,
            }
            if(Boolean(data.promotion)){
               purchase.discounted_terms = data.discounted_terms
               purchase.promotion = data.promotion
            }
            if(paymentType === 'download_content') {
               purchase.usd_terms = data.download_price
            }
         }
         if(type === 'livestream' && !data.id) {
            purchase.id = 'scheduled';
         }
         dispatch(actions.choosePurchaseCompleted(purchase));
      } catch (error) {
         const status = error?.response?.status;
         if('membership' === type && 403 !== status && 401 !== status){
            dispatch(push(Router.route('JOIN').getCompiledPath()));
         } else {
            let mediaUrl = null;
            switch (type) {
               case 'video':
                  mediaUrl = 'VIDEOS';
                  break;
               case 'photoset':
                  mediaUrl = 'PHOTOSETS';
                  break;
               case 'store':
                  mediaUrl = 'STORE';
                  break;
               case 'wallet_top_up':
                  mediaUrl = 'WALLET';
                  break;
               case 'tip':
                  mediaUrl = 'HOMEPAGE';
                  break;
               case 'video_unlock':
               case 'photo_unlock':
                  mediaUrl = 'HOMEPAGE';
                  break;
               default:
                  break;
            }
            if(403 !== error.response.status && 401 !== error.response.status){
               dispatch(push(Router.route(mediaUrl).getCompiledPath()));
            }
         }
      }
   };
}


export function initPaymentDeclinedOperations(token) {
   return async (dispatch) => {
      dispatch(actions.initPaymentDeclinedRequest())
      try {
         let { data } = await initPaymentDeclined(token)
         const apiType = {
            membership: 'membership-pricings',
            video_unlock: 'videos',
            video_download: 'videos',
            photoset_unlock: 'photosets',
            photoset_download: 'photosets',
            store: 'products',
            order_request: 'products',
            wallet_top_up: 'wallet',
            tip: 'tip',
            chat_photo_unlock: 'chat/messages',
            chat_video_unlock: 'chat/messages',
            chat_voice_unlock: 'chat/messages',
            mass_message: 'chat/messages',
            livestream: 'live-stream',
            chat_text_message: 'chat',
            chat_voice_message: 'chat',
            chat_photo_message: 'chat',
            private_mass_message: 'chat/messages',
            multiple_attachment: 'chat/messages',
         }
         let id = data.id;
         let { user_selected_payment_method, payment_system } = data
         let declinedId = id;
         if('chat_pay_per_message' === id){
            declinedId = null;
         }
         if(data.type === 'order_request') {
            declinedId = data?.payload?.id
         }


         let candidatePayments = await initCandidatePayment(declinedId, apiType[data.type])


         let usePayment = candidatePayments.data[user_selected_payment_method]

         let otherPaymentsSystems = []
         if('epoch' !== payment_system) {
            otherPaymentsSystems = usePayment?.payment_gateways?.filter(item => item !== data.payment_system)

            if(!otherPaymentsSystems?.length && ['products', 'order_request'].includes(apiType[data.type])) {
               otherPaymentsSystems = [data.payment_system]
            }
         }
         if(!otherPaymentsSystems.length){
            otherPaymentsSystems = [payment_system]
         }

         dispatch(actions.initPaymentDeclinedCompleted({ ...data, other_systems: otherPaymentsSystems }))
      } catch (error) {
         console.log({ error: error.response.data });
         // dispatch(push(Router.route('HOMEPAGE').getCompiledPath()));
      }
   }
}


export function validatePromoCodeOperation(code, isCodeByLink = false) {
   return async (dispatch) => {
      try {
         dispatch(actions.validatePromoCodeStart())
         await validatePromoCode({ promo_code: code })
         dispatch(actions.validatePromoCodeCompleted(code, isCodeByLink))

         // call memberships by query code and ....
         if(!isCodeByLink) {
            let param = null;
            if(QueryParams.getParam('videoId')) {
               param = {
                  type: 'video',
                  id: QueryParams.getParam('videoId'),
               }
            }
            if(QueryParams.getParam('recordId')) {
               param = {
                  type: 'record',
                  id: QueryParams.getParam('recordId'),
               }
            }
            if(QueryParams.getParam('photosetId')) {
               param = {
                  type: 'photoset',
                  id: QueryParams.getParam('photosetId'),
               }
            }
            if(QueryParams.getParam('chatId')) {
               param = {
                  type: 'chat',
               }
            }
            if(QueryParams.getParam('liveStreamId')) {
               let id = 'stream';
               if(QueryParams.getParam('liveStreamId') === 'chat') {
                  id = 'chat'
               }
               param = {
                  type: 'live_stream',
                  id,
               }
            }
            await dispatch(fetchMembershipsData(param, `promo_code=${ code }`, true))
         }
         //

      } catch (error) {
         dispatch(actions.validatePromoCodeFailed(error.response?.data?.promo_code[0]))
      }
   }
}
